module.exports = __webpack_public_path__ + "assets/img/n5.00a1070f.jpg";